/** Presentation only: never rewrite signed messages, identifiers or API data. */
export function brandText(text: string, locale = "fa"): string {
  const localBrand = locale === "ar" ? "يونيفرس ميتا" : "یونیورس متا";
  return text
    .replace(/Aran[\s_-]*DAO(?:\.xyz)?/gi, "UniverseMeta")
    .replace(
      /[آأإا]ران[\s\u200c_-]*(?:دائو|داو|داؤ|دو)|دائو[\s\u200c_-]*[آأإا]ران/gi,
      localBrand,
    );
}

/** Other sites' public content must never become navigation on this site. */
export function isIndependentContentLink(href: string): boolean {
  try {
    const url = new URL(href, "https://local.invalid");
    const host = url.hostname.toLowerCase();
    if (host === "t.me" && /^\/arandao/i.test(url.pathname)) return false;
    const excluded = [
      "ecoowin.com",
      "arandao.com",
      "arandao.xyz",
      "universemeta.com",
    ];
    return !excluded.some(
      (domain) => host === domain || host.endsWith(`.${domain}`),
    );
  } catch {
    return false;
  }
}

interface TextNode {
  type: string;
  value?: string;
  children?: TextNode[];
}

// Markdown text nodes only: URLs, code and cryptographic payloads stay intact.
export function remarkSiteBranding() {
  return (tree: TextNode) => {
    const visit = (node: TextNode) => {
      if (node.type === "text" && node.value)
        node.value = brandText(node.value);
      for (const child of node.children ?? []) visit(child);
    };
    visit(tree);
  };
}
